<template>
  <container :isModal="true" @close-modal="closeScreen()" :loading="loading">
    <template v-slot:header>
      <h3>Compartilhar via WhatsApp</h3>
    </template>
    <template v-slot:body>
      <div v-if="payload" class="p-formgrid p-grid">
        <div class="p-field p-fluid p-col-12">
          <input-with-label label="Prévia da mensagem" v-slot="l">
            <Textarea
              :id="l.id"
              v-model="payload.mensagem"
              :rows="10"
              readonly
              style="font-family: monospace; font-size: 0.875rem"
            />
          </input-with-label>
        </div>
        <div class="p-col-12">
          <button-group>
            <Button
              label="Abrir no WhatsApp"
              icon="pi pi-whatsapp"
              class="p-button-rounded p-button-success"
              @click="abrirWhatsApp"
            />
            <Button
              label="Copiar texto"
              icon="pi pi-copy"
              class="p-button-rounded p-button-text"
              @click="copiarTexto"
            />
          </button-group>
        </div>
      </div>
    </template>
  </container>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted, Ref } from "vue";
import {
  useOrcamentoService,
  WhatsAppPayloadResponse
} from "../../modules/business/orcamento/orcamentoBusiness";
import { useToast } from "../../modules/message";

interface ModalState {
  payload: WhatsAppPayloadResponse | null;
  loading: boolean;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  setup(props, { emit }) {
    const state = reactive<ModalState>({
      payload: null,
      loading: false,
      loadings: []
    });

    const closeScreen = () => emit("after-close");

    const abrirWhatsApp = () => {
      if (state.payload && state.payload.url) {
        window.open(state.payload.url, "_blank");
      }
    };

    const copiarTexto = () => {
      if (state.payload && state.payload.mensagem) {
        navigator.clipboard.writeText(state.payload.mensagem).then(
          () => useToast().success("Texto copiado"),
          () => useToast().error("Falha ao copiar texto")
        );
      }
    };

    onMounted(() => {
      const { getWhatsAppPayload, data } = useOrcamentoService();
      state.loading = true;
      getWhatsAppPayload(props.idOrcamento)
        .then(() => {
          state.payload = data.value as WhatsAppPayloadResponse;
          state.loading = false;
        })
        .catch(() => {
          state.loading = false;
          closeScreen();
        });
    });

    return {
      closeScreen,
      abrirWhatsApp,
      copiarTexto,
      ...toRefs(state)
    };
  },
  props: {
    idOrcamento: {
      type: Number,
      required: true
    }
  }
});
</script>

<style scoped lang="scss"></style>
